import { Injectable, WritableSignal, inject, signal } from '@angular/core';
import { Firestore, QuerySnapshot, collection, doc, documentId, getDocs, query, setDoc, updateDoc, where } from '@angular/fire/firestore';
import { HandleErrorService } from './services/log.service';


@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {
  
  errorHandler = inject(HandleErrorService)
  firestore = inject(Firestore)

  featureFlagRef = collection(this.firestore, 'featureFlags')


  // Contain the dataObject for feature flag status based on the users credentials. Ensure that this is pulled directly from firebase so it's always up to date
  data: WritableSignal<any> = signal({})
  accessLevel

  /**
   * Checks if the featureFlag is enabled in the data
   * 
   * @param featureFlag 
   * @returns boolean - true if enabled, false if disabled, true if flag doesn't exist (default to showing)
   */
  featureFlagEnabled(featureFlag) {

    if(featureFlag) {

      // Traverse the data object based on the values of featureFlag, converting it to object references along the way, getting the final value.
      const keys = featureFlag.split('.')
      let value = this.data()

      for(const key of keys) {
        // Handle missing keys gracefully - if a key doesn't exist, default to true (show the feature)
        if(value === undefined || value === null) {
          return true
        }
        value = value[key]
      }
      
      // If the final value is undefined (flag not configured), default to true
      return value ?? true
    }

    return true
  }

  async getFeatureFlags(accessLevel) {
    try {
        const docQuery = query(this.featureFlagRef, where(documentId(), '==', accessLevel))
        
        return getDocs(docQuery).then((querySnapshot: QuerySnapshot) => {

            const queryData = querySnapshot.docs.map(doc => doc.data());
            return queryData;
        })
    } catch(error) {
      this.errorHandler.log(error)
    }
  }

  async updateFeatureFlag(accessLevel, featureFlag) {
    try {
      const docRef = doc(this.firestore, 'featureFlags', accessLevel);
      await updateDoc(docRef, featureFlag);
    } catch(error) {
      this.errorHandler.log(error)
    }
  }

  async setFeatureFlag(accessLevel, featureFlag) {
    try {
      const docRef = doc(this.firestore, 'featureFlags', accessLevel);
      await setDoc(docRef, featureFlag);
    } catch(error) {
      this.errorHandler.log(error)
    }
  }
}
